import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async show(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/lead-vehicles/${id}`, {
            params: payload,
        });

        return response.data.data;
    },

    async image(id) {
        const response = await axios.get(`v1/lead-vehicles/${id}/image`);

        return response.data.data;
    },
};
